import * as yup from "yup";

export const initialValues = {
  id: "",
  title: "",
  description: "",
  status: "",
  createdAt: "",
  operarioId: "",
  clientId: "",
  viviendaId: "",
  serviceId: "",
};

export const validationSchema = yup.object().shape({
  title: yup.string().required("El título es requerido!"),
});
